import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useCallback, useState } from "react";
import PaperDraggable from "../../../../../../../../components/PaperDraggable";

export default function NumeroLancamento({
    open,
    defaultValue,
    onClose,
    onSubmitFiltros
}: NumeroLancamentoProps) {

    const [numeroLancamento, setNumeroLancamento] = useState<string>(defaultValue || "");

    const handleSubmit = useCallback(() => {
        onSubmitFiltros(numeroLancamento);
        onClose();
    }, [numeroLancamento, onClose, onSubmitFiltros]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={'xs'}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Número de Lançamento</DialogTitle>
            <DialogContent>
                <Box mt={1}>
                    <TextField
                        fullWidth
                        label="Número de Lançamento" variant="outlined"
                        value={numeroLancamento}
                        onChange={(e) => setNumeroLancamento(e.target.value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Box display={'flex'} gap={2}>
                    <Button variant="outlined" onClick={onClose}>
                        Fechar
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        Selecionar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

interface NumeroLancamentoProps {
    open: boolean
    defaultValue: string
    onClose: () => void
    onSubmitFiltros: (value: any) => void
}
